// modules/qualifications/index.ts
var QUAL_FIELDS = "id,name,abbreviation,category,cs_level,rx_level,provider_type,ics_position,sort_order";
var QualCSLevelOrder = {
  none: 0,
  witness: 1,
  dispenser: 2
};
var QualRxLevelOrder = {
  none: 0,
  dispenser: 1,
  prescriber: 2
};
var QualProviderTypeOrder = {
  none: 0,
  emt: 1,
  pmd: 2,
  nurse: 3,
  app: 4,
  physician: 5
};
export {
  QUAL_FIELDS,
  QualCSLevelOrder,
  QualProviderTypeOrder,
  QualRxLevelOrder
};
